const actionTypes = { SET_USER_PUBLIC_GALLERY_PROFILE_CONTENT: 'SET_USER_PUBLIC_GALLERY_PROFILE_CONTENT' };

module.exports = actionTypes;
